import styled from '@emotion/styled'
import { mergeDeepRight } from 'ramda'

export const SecondColumn = styled('div')(({ customCss = {} }) =>
  mergeDeepRight({}, customCss),
)
